(() => {
  if (customElements.get('mrc-newsletter')) return;
  customElements.define('mrc-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.key = 'muriclyn-newsletter-seen-v1';
      this.querySelectorAll('[data-news-close]').forEach(button => button.addEventListener('click', () => this.close(), options));
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
      this.dialog.addEventListener('close', () => this.release(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      }, options);
      const cartStarted = () => {
        clearTimeout(this.timer);
        this.remember();
        this.close();
      };
      document.addEventListener('muriclyn:cart:adding', cartStarted, options);
      document.addEventListener('muriclyn:cart:opening', cartStarted, options);
      document.addEventListener('shopify:section:select', event => {
        if (event.detail.sectionId === this.dataset.sectionId) this.show(true);
      }, options);
      document.addEventListener('shopify:section:deselect', event => {
        if (event.detail.sectionId === this.dataset.sectionId) this.close();
      }, options);
      if (this.querySelector('[data-news-result]')) {
        this.show(true);
        return;
      }
      let seen = false;
      try { seen = sessionStorage.getItem(this.key) === 'true'; } catch { seen = window.muriclynNewsletterSeen === true; }
      if (!seen && !window.Shopify?.designMode) this.timer = setTimeout(() => this.show(), Number(this.dataset.delay) * 1000);
    }
    remember() {
      if (window.Shopify?.designMode) return;
      window.muriclynNewsletterSeen = true;
      try { sessionStorage.setItem(this.key, 'true'); } catch {}
    }
    show(force = false) {
      if (!this.isConnected || (this.dialog.open && this.dialog.dataset.mrcMotion !== 'closing')) return;
      if (!force && (document.querySelector('dialog[open], .mrc-menu-open') || document.hidden)) return;
      this.trigger = document.activeElement;
      if (window.MuriclynMotion) {
        window.MuriclynMotion.open(this.dialog, this.trigger);
      } else {
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.locked = true;
      }
      this.remember();
      this.querySelector('[data-news-result="success"]')?.focus();
    }
    release() {
      if (!this.locked) return;
      document.documentElement.style.overflow = this.previousOverflow;
      this.locked = false;
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
    }
    close(immediate = false) {
      if (window.MuriclynMotion) {
        return window.MuriclynMotion.close(this.dialog, { immediate });
      }
      if (this.dialog?.open) this.dialog.close();
      this.release();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.close(true);
      this.controller?.abort();
    }
  });
})();
